import { RiGiftLine } from 'react-icons/ri';

import { ButtonProps, Typography } from '@mui/material';

import { ROUTES } from '@arrived/common';
import { FEATURE_FLAGS } from '@arrived/feature-flags';

import { ApplyFn, NAV_TYPE, NavItemProps } from '../navigation.types';
import { buildProfileLabel, BuildProfileLabelArgs } from './buildProfileLabel';
import {
  adminItem,
  handleApplySubItems,
  investNavItem,
  learnNavPrivateMultipleItem,
  logoutItem,
  myAccountItem,
  portfolioNavItem,
  transactionsNavItem,
} from './items';
import { handleApplySubPath } from './items/handleApplySubPath';

export const PrivateNavItems = (apply: ApplyFn, subPath?: string): NavItemProps[] => {
  return [portfolioNavItem, investNavItem, transactionsNavItem, learnNavPrivateMultipleItem]
    .map(handleApplySubPath(subPath))
    .map(handleApplySubItems(apply));
};

export const PrivateSecondaryItems = (
  apply: ApplyFn,
  logoutButtonProps: ButtonProps<any>,
  profileArgs: Omit<BuildProfileLabelArgs, 'isMobile'>,
  subPath?: string
): NavItemProps[] => {
  const isReferralProgramActive = FEATURE_FLAGS.REFERRAL_PROGRAM;

  const subItems = [myAccountItem, logoutItem(logoutButtonProps)].map(handleApplySubPath(subPath));
  if (profileArgs.isAdmin) {
    subItems.push(adminItem);
  }

  const ProfileDropdownItem: NavItemProps = apply({
    type: NAV_TYPE.MULTIPLE,
    text: buildProfileLabel({ ...profileArgs, includeBetaMode: false }),
    subItems: subItems.map(apply),
  });

  const referralComponent: NavItemProps = apply({
    type: NAV_TYPE.SINGLE,
    text: (
      <Typography
        color={({ palette }) => palette.aqua[600]}
        variant="h5.medium"
        component="div"
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <RiGiftLine />
      </Typography>
    ),
    path: ROUTES.referral.earn,
  });

  if (isReferralProgramActive && profileArgs.isUserReferralBeta) {
    return [referralComponent, ProfileDropdownItem];
  } else {
    return [ProfileDropdownItem];
  }
};

export const PrivateNavItemsMobile = (
  apply: ApplyFn,
  profileArgs: Omit<BuildProfileLabelArgs, 'isMobile'>,
  subPath?: string
): NavItemProps[] => {
  const ProfileItem: NavItemProps = {
    text: buildProfileLabel({ ...profileArgs, includeBetaMode: true }),
  };

  const startArray: NavItemProps[] = [ProfileItem, myAccountItem, portfolioNavItem, investNavItem, transactionsNavItem];

  profileArgs.isAdmin && startArray.push(adminItem);

  return startArray
    .concat([learnNavPrivateMultipleItem])
    .map(handleApplySubPath(subPath))
    .map(handleApplySubItems(apply));
};
